var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgDownArrow = function SvgDownArrow(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "inherit",
    height: "inherit",
    fill: "none",
    viewBox: "0 0 12 6"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.9 5.995a1.07 1.07 0 0 1-.594-.253L.824 1.9A1.068 1.068 0 1 1 2.212.28L6 3.527 9.788.279A1.068 1.068 0 1 1 11.176 1.9L6.694 5.742c-.22.189-.506.28-.794.253"
  })));
};
export default SvgDownArrow;